import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidsQuery,
  PaginationOptions,
  SearchBidsRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const BIDS_QUERY = graphql(`
  query Bids($request: SearchBidsRequest!, $pagination: PaginationOptions!) {
    bids(SearchBidRequest: $request, PaginationOptions: $pagination) {
      total
      valueSum
      results {
        id
        name
        description
        value
        updatedAt
        submissionDate
        awardDate
        stage {
          id
          name
          color
          iconName
          iconColor
        }
        buyers {
          id
          name
          logoUrl
        }
        customBuyers {
          id
          name
        }
        assignedTo {
          guid
          firstName
          lastName
          active
        }
        createdBy {
          guid
          firstName
          lastName
          active
        }
        suppliers {
          id
          name
          logoUrl
        }
        framework {
          id
          title
        }
      }
    }
  }
`);

export type BidData = BidsQuery["bids"]["results"][0];

export function useBids(
  request: SearchBidsRequest,
  pagination: PaginationOptions,
  options?: UseQueryOptions<BidsQuery, unknown, BidsQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["bids", request, pagination],
    BIDS_QUERY,
    [{ request, pagination }],
    {
      staleTime: 1000 * 60 * 60, // 1 hour
      ...options,
    },
  );

  return {
    data: data?.bids,
    ...rest,
  };
}
